<div>
    <table mat-table [dataSource]="dataSource" *ngIf="dataSource?.data?.length !== 0" class="w-100" matSort
        matSortActive="id" matSortDirection="asc">

        <!-- Coluna: nome (fixo) -->
        <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
            <td mat-cell *matCellDef="let element; let i = index">
                Programa do Trabalho
            </td>
        </ng-container>

        <!-- Coluna: Data Preenchimento -->
        <ng-container matColumnDef="dataHoraFin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Data de Preenchimento</th>
            <td mat-cell *matCellDef="let element">
                {{ element?.dataHoraFin | date: "dd/MM/yyyy" }}
            </td>
        </ng-container>

        <!-- Coluna: Auditor Responsável  -->
        <ng-container matColumnDef="nomeResponsavelFin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Auditor Responsável</th>
            <td mat-cell *matCellDef="let element">
                {{ element?.nomeResponsavelFin }}
            </td>
        </ng-container>

        <!-- Coluna: Status  -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="element?.status === 1" class="badge bg-gray-dark text-xs">{{ element?.statusDesc }}</span>
                <span *ngIf="element?.status === 2" class="badge bg-success text-xs">{{ element?.statusDesc }}</span>
                <span *ngIf="element?.status === 3" class="badge bg-warning text-xs">{{ element?.statusDesc }}</span>
            </td>
        </ng-container>

        <!-- Coluna: Ações -->
        <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
            <td mat-cell *matCellDef="let element; let index">
                <div class="w-100 d-flex justify-content-center">
                    <button class="icon-btn btn btn-info btn-xs" title="Visualizar Programa de Trabalho"
                        (click)="modalQuestao('Visualizar', true, element)">
                        <i class="far fas fa-eye"></i>
                    </button>
                    <button
                        type="button"
                        *ngIf="!visualizar"
                        [disabled]="element?.status === 1 || !element?.habilitaAcaoPTMatrizConstatacao"
                        class="btn btn-primary btn-xs ml-1"
                        title="Preencher Programa de Trabalho"
                        (click)="modalQuestao('Preencher', false, element)">
                        <i class="fas fa-pen"></i>
                    </button>
                    <button type="button" class="btn btn-info btn-xs ml-1"
                        title="Imprimir Programa de Trabalho" (click)="imprimir(element)">
                        <i class="far fas fa-print"></i>
                    </button>
                    <button type="button" [disabled]="element?.status === 2 || element?.status === 3 || !element?.habilitaAcaoPTMatrizConstatacao" *ngIf="!visualizar"
                        class="btn btn-warning btn-xs ml-1" title="Habilitar Programa de Trabalho"
                        (click)="habilitar(element)">
                        <i class="fas fa-play"></i>
                    </button>
                    <button
                        type="button"
                        *ngIf="!visualizar"
                        [disabled]="element?.status === 1 || !element?.habilitaAcaoPTMatrizConstatacao"
                        class="btn btn-warning btn-xs ml-1"
                        title="Desabilitar Programa de Trabalho"
                        (click)="desabilitar(element)">
                        <i class="fas fa-pause"></i>
                    </button>
                </div>
            </td>
        </ng-container>

        <!-- Cabeçalho da Tabela -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- Linhas  -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns">
        </tr>
    </table>

    <!-- Sem dados -->
    <h5 *ngIf="dataSource?.data?.length === 0" class="table-no-data">
        Nenhum registro encontrado.
    </h5>

    <!-- Paginador -->
    <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>
